var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"injuredMark"},_vm._l((_vm.tagInfo),function(item,index){return _c('div',{key:index,staticClass:"tag",style:({
      top: (item.axisY * _vm.width) / 100 - 9 + 'px',
      left: (item.axisX * _vm.height) / 100 - 9 + 'px',
      transform: !_vm.isPc ? 'scale(0.5)' : '',
    })},[_c('a',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(index + 1))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }